import React from 'react';
import { AuthPageContent } from '@/modules/Auth';

const SignIn = (): JSX.Element => <AuthPageContent />;

export default SignIn;
